import {
  AppBar,
  Drawer,
  Grid,
  Hidden,
  IconButton,
  Toolbar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Closeicon from "../../src/assets/images/SheetClose.svg";
import AppStore from "../assets/images/AppStore.svg";
import Close from "../assets/images/close.svg";
import Doctall from "../assets/images/doctall.svg";
import Logo from "../assets/images/doctall_logo_white.svg";
import GooglePlay from "../assets/images/GooglePlay.svg";
import Group from "../assets/images/Group.svg";
import Icon from "../assets/images/Icon.svg";
import Icon2 from "../assets/images/Icon2.svg";
import Icon4 from "../assets/images/Icon4.svg";
import Icon5 from "../assets/images/linkedIN.svg";
import FooterIcon from "../assets/images/MobFooterDrop.png";
import MenuIcon from "../assets/images/MobMenu.png";
import SearchIcon from "../assets/images/MobSearch.png";
import SearchBack from "../assets/images/searchBack.svg";
import SearchClose from "../assets/images/searchClose.svg";
import DownArrow from "../assets/images/sectionarrow.svg";
import { AutoSuggestField } from "../components";
import { Modal } from "react-bootstrap";
import Popup from "./popup";
import {
  footerLinks,
  mobfooterLinks,
  mobilesectionLinks2,
  MOBsectionLinks,
  sectionLinks,
  sectionLinks2,
} from "./utils";

import SearchFilter from "./../../src/components/Advance-Search/SerchFilter";

import DropItem from "../assets/images/dropSys.svg";
import RadioDrop from "../assets/images/radiodrop.svg";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import axios from "axios";
import CryptoJS from "crypto-js";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import LongDurationToast from "../components/long-duration-toast/LongDurationToast";
import useOnClickOutside from "../hooks/useOutsideClickhandler";
import useWindowSize from "../hooks/useWindowSize";
import { logout, SearchVal } from "../redux/auth/actions";
import { passcodeKey, tokenKey, usernameKey } from "../utils/constants";
import "./Layout.scss";
import styles from "./styles";
import Header from '../components/Header/Header';
import { Toast } from "../components";
import Navbar from "../components/HeaderLatest/Navbar.js";

const useStyles = makeStyles((theme) => styles(theme));

/**
 *
 * @param {object} props
 * @returns
 */
export default function Layout(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [auth, setAuth] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const { children, searching } = props;
  const [drawerOpen, setDrawer] = React.useState(false);
  const [submenu, setMenu] = React.useState("Dianostic");
  const [authMenu, setAuthMenu] = useState(false);
  const classes = useStyles();
  const [width, height] = useWindowSize();
  const [mobileview, setMobileView] = useState(false);
  const [sideoption, setsideoption] = useState("");
  const [searchselection, setSearchselection] = useState(false);
  const [searchtxt, setsearchtxt] = useState("");
  const [fetchData, setFetchData] = useState([]);
  const [cartCount, setCartCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [errorType, setErrorType] = useState("");
  const [toastVisibility, setToastVisibility] = useState("");

  const [footer, setfooterselection] = useState([]);
  const [update, setupdate] = useState(false);
  const [cookies, setCookie] = useCookies([usernameKey, passcodeKey, tokenKey]);
  const [joinMailId, setJoinMailId] = useState("");
  const [mailError, setMailError] = useState(false);
  // const [addRelative, setAddRelative] = useState(false);
  const [addRelative, setAddRelative] = useState(false);
  const [popup, setpopup] = useState(false);
  const cities = useSelector((state) => state.auth.cities);

  const [toastOpen, setToastOpen] = useState(false);

  const [openpopup, setOpenPopup] = useState(false)

  // function getHighlightedText(text, highlight) {
  //   try {

  //     // Split on highlight term and include term into parts, ignore case
  //     const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
  //     return <span> {parts.map((part, i) =>
  //       <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold', backgroundColor: '#FFAD05' } : {}}>
  //         {part}
  //       </span>)
  //     } </span>;
  //   } catch (error) {
  //     // onSuggestionsClearRequested()
  //   }

  // }

  function getHighlightedText(text, highlight) {
    try {
      // Split on highlight term and include term into parts, ignore case
      const parts = text.split(new RegExp(`(${highlight})`, "gi"));
      return (
        <span>
          {" "}
          {parts.map((part, i) => (
            <span
              key={i}
              style={
                part.toLowerCase() === highlight.toLowerCase()
                  ? { fontWeight: "bold", backgroundColor: "#FFAD05" }
                  : {}
              }
            >
              {part}
            </span>
          ))}{" "}
        </span>
      );
    } catch (error) {
      setFetchData([]);
    }
  }

  const handlePopupClose = () => {
    setOpenPopup(false);
  };

  // function renderSuggestion(suggestion) {
  //   return <>
  //     <span>{getHighlightedText(suggestion.additionalName.toString().trim())}</span><br></br>
  //     <span style={{ color: 'blue' }} >{`Also Known as :      ${suggestion.name.toString()}`}</span><br></br>
  //   </>
  // }

  // function getSuggestionValue(suggestion) {
  //   setSuggestionsObject(suggestion)
  //   dispatch(SearchVal(suggestion))
  //   return suggestion.name;
  // }

  useEffect(() => {
    if (width && width < 960) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, [width]);
  const handleDrawerToggle = () => {
    setDrawer(!drawerOpen);
  };
  useEffect(() => {
    if (user.isAuthenticated === true && user.verified === true) {
      setAuth(true);
    } else {
      setAuth(false);
    }
  }, [user.isAuthenticated]);

  useEffect(() => {
    if (user.isAuthenticated === true && user.verified === true) {
      getCartCount();
    }
  }, []);

  const handleRelativePopup = () => {
    window.scroll(0, 500);
    setpopup(true);
  };
  const getCartCount = async () => {
    try {
      // if (user && user.uuid) {
      //   let response = await axios.get(`${process.env.REACT_APP_API_URL}/order/cart/shoppingcartlist/${user.uuid}`)
      //   if (response) {
      //     if (response.data && response.data.shoppinglist)
      //       setCartCount(response.data.shoppinglist.length)
      //   }
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const setfooter = (type) => {
    let arr = footer;
    if (footer.indexOf(type) > -1) {
      arr = footer.filter((e) => e != type);
    } else {
      arr.push(type);
    }
    setfooterselection(arr);
    setupdate(!update);
  };

  const [searchCriteria, setSearchCriateria] = useState("startwith");


  const apiFetch = async (val) => {
    setFetchData([]);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/labtest/diagnostic/searchLists?searchType=${searchCriteria}&value=${val}`
      )
      .then((res) => {
        if (res.status === 200) {
          let brdata = [];
          res.data.data.map((i) => {
            brdata.push({
              name: i.doc.standardisedtestname,
              additionalName: i.doc.partnerstestname,
              uuid: i.doc.testname_uuid,
            });
          });
          setFetchData(brdata);
        } else {
          // onSuggestionsClearRequested()
          // setToastOpen(true);
          setOpenPopup(true)
          // setToastMessage("We apologize for the inconvenience. The selected test(s) are currently not available in the selected location,you can try near by location or contact our team via WhatsApp at +2349010996000 for assistance");
          // setToastMessage("We couldn't find any results for your search. Contact our team on WhatsApp at +2349010996000 for assistance. We're here to help!")
        }
      })
      .catch((err) => {
        console.log(err);
        // setToastOpen(true);
        setOpenPopup(true);
        // setToastMessage("We apologize for the inconvenience. The selected test(s) are currently not available in the selected location,you can try near by location or contact our team via WhatsApp at +2349010996000 for assistance");
        // setToastMessage("We couldn't find any results for your search. Contact our team on WhatsApp at +2349010996000 for assistance. We're here to help!")
        // onSuggestionsClearRequested()
      });
  };

  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function getSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === "") {
      return [];
    }

    const regex = new RegExp("^" + escapedValue, "i");

    return fetchData.filter((i) => regex.test(i.name));
  }
  const onChange = (event) => {
    setsearchtxt(event.target.value);
    apiFetch(event.target.value);
    if (event.target.value.length === 0) {
      // dispatch(SearchVal(...getSuggestions(event.target.value)));
    }
  };
  const onClear = () => {
    setsearchtxt("");
    setSearchselection(false);
    setFetchData([]);
    dispatch(SearchVal(...getSuggestions("")));
  };

  const getLoginDetails = () => {
    let userName = user.username;
    let password = " ";
    if (localStorage.getItem("PASSCODE") !== null || undefined) {
      password = localStorage.getItem("PASSCODE");
    } else if (localStorage.getItem("PWD") !== null || undefined) {
      password = localStorage.getItem("PWD");
    }
    // let password = localStorage.getItem("PWD");
    // console.log(localStorage.PASSCODE, "password")
    let data = password + userName;
    let encrypted = CryptoJS.AES.encrypt(data, "doctall");
    return encrypted.toString().replaceAll("/", "DMP");
  };

  const redirectToConsumerApp = (route) => {
    try {
      let url = "";
      let consumerUrl = process.env.REACT_APP_SITE_URL;

      console.log(route, "routeroute")
      switch (route) {
        case "HEALTH_PROFILE":
          url = `${consumerUrl}/profile`;
          window.location.href = url;
          break;
        case "RELATIVES":
          url = `${consumerUrl}/relatives`;
          window.location.href = url;
          break;
        case "CHANGE_PASSCODE":
          url = `${consumerUrl}/changePasscode`;
          window.location.href = url;
          break;
        case "ORDERS":
          let url = `${consumerUrl}/orders-result`;
          window.location.href = url;
          break;
        default:
          url = `${consumerUrl}/`;
          window.location.href = url;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleJoinMailId = (event) => {
    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let validation = emailRegex.test(event);
    if (!validation) {
      setMailError(true);
    } else {
      setMailError(false);
      setJoinMailId(event);
    }
  };

  const handleJoinMail = () => {
    if (joinMailId) {
      setMailError(false);
      joinMail();
    } else {
      setMailError(true);
    }
  };

  const joinMail = async () => {
    let payLoad = {
      email: joinMailId,
    };

    try {
      let response = await axios.post(
        `${process.env.REACT_APP_API_URL}/bulknotification/subscribe`,
        payLoad
      );

      if (response) {
        setJoinMailId("");
        document.getElementById("InputID").value = "";
        setToastVisibility(true);
        // setToastMessage("Your Subscription Request added successfully !");
        setToastMessage('You have been successfully added to the mailing list');
        setErrorType("success");
      }
    } catch (error) {
      if (error && error.response) {
        setToastVisibility(true);
        setToastMessage("" + error.response.data);
        setErrorType("error");
        setJoinMailId("");
      }
    }
  };

  const phoneNumber = "+2349010996000";
  const boldStyle = {
    fontWeight: 'bold',
    cursor: "grab",
    color: "#ff5c3c",
    fontSize: "15px"
  };

  const handleWhatsAppClick = (event) => {
    console.log(event, "click on the whatsapp num")
    const formattedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove any non-numeric characters
    const whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneNumber}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <div>
      <Dialog
        backdrop="static"
        open={popup}
        onClose={() => setpopup(false)}
        // fullWidth={fullWidth}
        style={{ minWidth: "100%" }}
        maxWidth={"100%"}
        minWidth={"md"}
      >
        <img
          alt="icon"
          src={Closeicon}
          onClick={() => setpopup(false)}
          className="Icon"
        ></img>
        <DialogContent style={{ minWidth: "1000px", minHeight: "400px" }}>
          {/* <div className="parentContainer"> */}
          <Popup city={cities} close={() => setpopup(false)} />
          {/* </div>
           */}
        </DialogContent>
      </Dialog>
      <LongDurationToast
        text={toastMessage}
        type={errorType}
        open={toastVisibility}
        setClose={() => {
          setToastVisibility(false);
        }}
      />

      <Modal
        show={openpopup}
        onHide={handlePopupClose}

      >
        <div className="parentContainer" style={{ marginTop: "253px" }}>
          <div style={{ marginTop: "200px !important", zIndex: "10000000 !important" }}>
            {/* <Modal.Header>
              </Modal.Header> */}
            <div>
              We couldn't find any results for your search. Contact our team on WhatsApp at <a target="" onClick={handleWhatsAppClick} style={boldStyle}>{phoneNumber}</a> for assistance. We're here to help!
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              className="popup_btn"
              style={
                { backgroundColor: "#FF5C3", display: "flex", justifyContent: "center" } //opacity: "0.5", cursor: "not-allowed"
              }
              onClick={() => {
                setOpenPopup(false);
              }}
            >
              Close
            </div>
          </div>
        </div>
      </Modal>

      <Toast
        text={toastMessage}
        type="error"
        open={toastOpen}
        setClose={() => {
          setTimeout(() => {
            setToastOpen(false);
          }, 3000)
        }}
      />
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.container}>

          <Header />
          {/* <Navbar /> */}
          {/* <Grid
              container
              alignItems="center"
              justify="center"
              className={classes.sectionLinks}
            >
              {(sectionLinks || []).map((s) => (
                <Grid key={s.id} item>
                  <a
                    target="_blank"
                    style={{
                      fontFamily: "visuelt-regular",
                      fontSize: "14",
                      color: "white",
                    }}
                    href={
                      s.path == "http://test-consumer.doctall.com"
                        ? `${process.env.REACT_APP_SITE_URL
                        }/${"dashboardData"}/${getLoginDetails()}`
                        : `${s.path}`
                    }
                    rel="noreferrer"
                  >
                    {s.label}
                  </a>
                </Grid>
              ))}
            </Grid> */}
          <Hidden smDown>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              className={classes.middleSection}

            >
              <Grid item>
                <img
                  src={Doctall}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("/");
                  }}
                  alt="doctall logo"
                />
              </Grid>
              <Grid item>
                <AutoSuggestField />
              </Grid>
              <div className="menulistresponive">
                <Grid
                  container
                  justify="space-between"
                  alignItems="center"
                  style={{ minWidth: "240px" }}
                >
                  <Grid item>
                    <a
                      style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
                      href="/faq"
                      // href="/"
                      // target="_blank"
                      rel="noreferrer"
                    >
                      FAQs
                    </a>
                  </Grid>
                  {auth ? (
                    <>
                      <Grid item>
                        <Link
                          onClick={() => {
                            history.push("/shoppingCart");
                          }}
                          className={classes.group}
                        >
                          <img
                            src={require("../assets/images/cart.svg").default}
                            alt=""
                          />
                          Cart
                        </Link>
                      </Grid>
                      <Grid item>
                        {/* style={{ position: 'relative' }} */}
                        <div
                          className={classes.group}
                          style={{ position: "relative" }}
                          onClick={() => {
                            authMenu === false
                              ? setAuthMenu(true)
                              : setAuthMenu(false);
                          }}
                        >
                          {user && user.profile && user.profile.profile_pic ? (
                            <img
                              src={user.profile.profile_pic}
                              alt="group"
                              className="mob-profile"
                            />
                          ) : (
                            <img
                              src={Group}
                              alt="group"
                              className="mob-profile"
                            />
                          )}
                          {authMenu ? (
                            <div
                              className={classes.hideDiv}
                              style={{ width: "600%" }}
                              onMouseLeave={() => setAuthMenu(false)}
                            >
                              <p
                                className={classes.hideDivElements}
                                onClick={() => {
                                  history.push("/cart-update");
                                }}
                              >
                                Add Recipient
                              </p>

                              <a
                                className={classes.hideDivElements}
                                // onClick={() =>
                                //   redirectToConsumerApp("HEALTH_PROFILE")
                                // }
                                href={`${process.env.REACT_APP_SITE_URL}/profile`}
                                target="_blank"
                                style={{textDecoration:"none",color:"#15408D",lineHeight:"35px"}}
                              >
                                Health Profile
                              </a>
                              <br />
                              <a
                                className={classes.hideDivElements}
                                // onClick={() =>
                                //   redirectToConsumerApp("RELATIVES")
                                // }
                                href={`${process.env.REACT_APP_SITE_URL}/relatives`}
                                target="_blank"
                                style={{textDecoration:"none",color:"#15408D",fontSize:"16px"}}
                              >
                                Relatives
                              </a>
                              <p
                                className={classes.hideDivElements}
                                onClick={
                                  () => redirectToConsumerApp("CHANGE_PASSCODE")
                                  // history.push("/changePasscode")
                                }
                              >
                                Change Passcode
                              </p>
                              <a
                                className={classes.hideDivElements}
                                // onClick={() => redirectToConsumerApp("ORDERS")}
                                href={`${process.env.REACT_APP_SITE_URL}/orders-result`}
                                target="blank"
                                style={{textDecoration:"none",color:"#15408D"}}
                              >
                                Order & Result
                              </a>
                              <p
                                className={classes.hideDivElements}
                                onClick={() => {
                                  setCookie(usernameKey, null);
                                  setCookie(passcodeKey, null);
                                  setCookie(tokenKey, null);
                                  dispatch(logout());
                                  history.push("/login");
                                }}
                              >
                                Sign Out
                              </p>
                            </div>
                          ) : null}
                        </div>
                      </Grid>
                    </>
                  ) : (
                    <Grid item>
                      <Link to="/login" className={classes.group}>
                        <img src={Group} alt="group" />
                        Login
                      </Link>
                    </Grid>
                  )}
                </Grid>
              </div>
            </Grid>
            <Grid
              container
              alignItems="center"
              justify="space-between"
              className={classes.sectionLinks2}
            >
              <Grid item md={6}>
                <Grid container alignItems="center">
                  {/* <div
                    style={{
                      display: "flex",
                      paddingLeft: "6%",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        paddingRight: "3%",
                        display: "flex",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        onClick={() => {
                          setMenu("Dianostic");
                        }}
                      >
                        {" "}
                        Diagnostic Tests
                      </span>{" "}
                      <DropClick />
                      {submenu == "Dianostic" && (
                        <div
                          style={{
                            backgroundColor: "#FFAD05",
                            height: 4,
                            width: 125,
                            bottom: 0,
                            position: "absolute",
                          }}
                        />
                      )}
                    </div> */}
                  {/* <div
                      style={{
                        paddingRight: "2%",
                        display: "flex",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        onClick={() => {
                          setMenu("BioCheck");
                        }}
                      >
                        BioCheck Panels{" "}
                      </span>
                      <DropClick />
                      {submenu == "BioCheck" && (
                        <div
                          style={{
                            backgroundColor: "#FFAD05",
                            height: 4,
                            width: 125,
                            bottom: 0,
                            position: "absolute",
                          }}
                        />
                      )}
                    </div> */}
                  {/* </div> */}
                  {/* {(sectionLinks2 || [])
                    .filter((_) => _.view === "md")
                    .map((s) => (
                      <Grid key={s.id} item className={classes.subLinks}>
                        <Link to={s.path}>
                          {s.label}
                          {s.icon ? (
                            <img
                              src={s.icon}
                              className={classes.icon}
                              alt="icon"
                            />
                          ) : null}
                        </Link>
                        {s.childRoutes && s.childRoutes.length > 0 ? (
                          <div className={`dropdownList ${classes.ckbd}`}>
                            {(s.childRoutes || []).map((t) => (
                              <Grid key={t.id} item>
                                <Link to={t.path}>{t.label}</Link>
                              </Grid>
                            ))}
                          </div>
                        ) : null}
                      </Grid>
                    ))} */}
                </Grid>
              </Grid>
              <Grid item md={6}>
                <Grid container alignItems="center" justify="flex-end">
                  <Grid item className={classes.subLinks}>
                    {/* <a
                      target="_blank"
                      // href={"/https://docs.google.com/spreadsheets/d/1uWUO0IQGk34ypf5roX681DtJvfdzOCBT/edit?usp=sharing&ouid=101004646910894655023&rtpof=true&sd=true"}
                      style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
                    > */}
                    <p
                      style={{
                        fontFamily: "visuelt-regular",
                        fontSize: 16,
                        marginTop: "12%",
                        cursor: "pointer",
                      }}
                      onClick={() => setpopup(true)}
                    >
                      Find Partner Branch
                    </p>
                    {/* </a> */}
                  </Grid>
                  <Grid item className={classes.subLinks}>
                    <a
                      href="https://forms.clickup.com/f/4hnn1-543/J66634MTO2OOU28XUR/"
                      style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
                      // target="_blank"
                      rel="noreferrer"
                    >
                      Contact Us
                    </a>{" "}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden mdUp>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              className="mobhead-container"
            >
              {!searchselection ? (
                <>
                  <Grid item>
                    <IconButton
                      aria-label="open drawer"
                      onClick={handleDrawerToggle}
                    >
                      <img src={MenuIcon} alt="menuicon" className="mob-menu" />
                    </IconButton>
                    {/* <img src={Doctall} alt="doctall" className="mob-logo" /> */}
                    <img
                      src={Doctall}
                      className="mob-logo"
                      onClick={() => {
                        history.push("/");
                      }}
                      alt="doctall logo"
                    />
                  </Grid>
                  <Grid item style={{ display: "flex" }}>
                    <IconButton
                      aria-label="open drawer"
                      onClick={() => {
                        setSearchselection(true);
                      }}
                    >
                      <img
                        src={SearchIcon}
                        alt="search-menu"
                        className="mob-search"
                      />
                    </IconButton>
                    {auth ? (
                      <Link
                        className={classes.group}
                        style={{ position: "relative" }}
                        onClick={() => {
                          authMenu === false
                            ? setAuthMenu(true)
                            : setAuthMenu(false);
                        }}
                      >
                        <div>
                          {user && user.profile && user.profile.profile_pic ? (
                            <img
                              src={user.profile.profile_pic}
                              alt="group"
                              className="mob-profile"
                            />
                          ) : (
                            <img
                              src={Group}
                              alt="group"
                              className="mob-profile"
                            />
                          )}
                        </div>
                        {authMenu ? (
                          <div
                            className={classes.hideDiv}
                            style={{ width: "600%" }}
                          >
                            <p
                              className={classes.hideDivElements}
                              onClick={() => {
                                history.push("/cart-update");
                              }}
                            >
                              Add Recipient
                            </p>

                            <p
                              className={classes.hideDivElements}
                              onClick={() =>
                                redirectToConsumerApp("HEALTH_PROFILE")
                              }
                            >
                              Health Profile
                            </p>
                            <p
                              className={classes.hideDivElements}
                              onClick={() => redirectToConsumerApp("RELATIVES")}
                            >
                              Relatives
                            </p>
                            <p
                              className={classes.hideDivElements}
                              onClick={
                                () => redirectToConsumerApp("CHANGE_PASSCODE")
                                // history.push("/changePasscode")
                              }
                            >
                              Change Passcode
                            </p>
                            <p
                              className={classes.hideDivElements}
                              onClick={() => redirectToConsumerApp("ORDERS")}
                            >
                              Order & Result
                            </p>
                            <p
                              className={classes.hideDivElements}
                              onClick={() => {

                                setCookie(usernameKey, null);
                                setCookie(passcodeKey, null);
                                setCookie(tokenKey, null);
                                dispatch(logout());
                                history.push("/login");
                              }}
                            >
                              Sign Out
                            </p>
                          </div>
                        ) : null}
                      </Link>
                    ) : (
                      <Link to="/login" className={classes.group}>
                        <img src={Group} alt="group" style={{ maxWidth: "39%" }} className="mob-profile" />
                      </Link>
                    )}
                    {/* <Link to="/login"><IconButton
                      aria-label="open drawer"
                      onClick={() => { }}

                    >
                     <img src={Group} alt="profile-menu" className="mob-profile" />
                    </IconButton></Link> */}
                  </Grid>
                </>
              ) : (
                <>
                  <div className="searchContainer">
                    <div
                      className="navBack"
                      onClick={() => {
                        setSearchselection(false);
                      }}
                    >
                      <img src={SearchBack} alt="search-menu" />
                    </div>
                    <div className="mob-search-container-top">
                      <img
                        src={SearchIcon}
                        alt="search-icon"
                        className="search2Icon"
                      />
                      <input
                        //  placeholder="Search for Tests111" 
                        // placeholder="Search for Tests"
                        placeholder="Search from over 6000 tests"
                        type="text"
                        value={searchtxt}
                        onChange={onChange}
                      />
                      <img
                        src={SearchClose}
                        onClick={() => {
                          onClear();
                        }}
                        alt="search-menu"
                        className="search2Close"
                      />
                    </div>
                    {/* <div style={{ display: "flex", width: "100%", margin: "0px 10px" }}>
                      <SearchFilter serachFilter={(event) => setSearchCriateria(event)} />
                    </div> */}
                  </div>
                  <div xs={12} sm={12} style={{ display: "flex", justifyContent: "center" }}>
                    <SearchFilter serachFilter={(event) => setSearchCriateria(event)} />
                  </div>

                  {(fetchData.length > 0 && (
                    <div className="searchoverlay_mob">
                      <div className="valHolder">
                        <div className="titlesearch">{`Suggestions (${fetchData.length} Matches)`}</div>
                        <div>
                          {fetchData.map((e, i) => {
                            return (
                              <div
                                key={`searchval-${i}`}
                                onClick={() => {
                                  dispatch(
                                    SearchVal(...getSuggestions(e.name))
                                  );
                                  // history.push("/populartest");
                                  // history.push("/search-results");
                                  let encryptedId = CryptoJS.AES.encrypt(
                                    JSON.stringify(e.uuid),
                                    "my-secret-key@123"
                                  ).toString();
                                  history.push({
                                    pathname: "/search-results",
                                    search:
                                      "?=" +
                                      e.name.replace(/ /g, "-") +
                                      "&" +
                                      encryptedId,
                                  });
                                  setSearchselection(false);
                                }}
                                className="searchlistval"
                              >
                                <span
                                  style={{
                                    color: "#191716 !important",
                                    width: "100%",
                                  }}
                                >
                                  {getHighlightedText(
                                    e.additionalName.toString().trim(),
                                    searchtxt.toString().trim()
                                  )}
                                  <br></br>
                                </span>
                                <span
                                  style={{
                                    color: "#191716 !important",
                                    width: "100%",
                                    fontSize: "14px",
                                  }}
                                >
                                  {"Also Known as"} : {e.name}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )) ||
                    ""}
                </>
              )}
            </Grid>
          </Hidden>
        </Toolbar>
        <Hidden mdUp implementation="js">
          <Drawer
            variant="temporary"
            anchor={"left"}
            open={drawerOpen}
            classes={{
              paper: classes.drawerPaper,
            }}
            onClose={handleDrawerToggle}
          >
            <Grid container direction="column">
              <Grid item xs={12} style={{ textAlign: "start" }}>
                <IconButton
                  aria-label="open drawer"
                  onClick={handleDrawerToggle}
                  style={{ padding: 15, margin: "0.5em" }}
                >
                  <img src={Close} alt="Close" />
                </IconButton>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ backgroundColor: "#F7F8FB", padding: "15px" }}
              >
                <Grid container direction="column">
                  <div className="mob-category">CATEGORIES</div>
                  {(mobilesectionLinks2 || []).map((s) => (
                    <Grid
                      key={s.id}
                      item
                      xs={12}
                      className={classes.drawerLinks}
                    >
                      <Link
                        onClick={() => {
                          setsideoption(s.label);
                        }}
                        style={{
                          color: "#0c44ac",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {s.label}
                        {s.icon ? (
                          <img
                            src={s.icon}
                            className={classes.icon}
                            alt="icon"
                          />
                        ) : null}
                      </Link>
                      {(sideoption == s.label && (
                        <Grid container>
                          {(s.childRoutes || []).map((c) => (
                            <Grid
                              key={s.id}
                              item
                              xs={12}
                              className={classes.drawerLinks}
                            >
                              <Link to={c.path} style={{ color: "#0c44ac" }}>
                                {c.icon ? (
                                  <img
                                    src={c.icon}
                                    style={{ paddingRight: 8, width: 18 }}
                                    alt="icon"
                                  />
                                ) : null}
                                {c.label}
                              </Link>
                            </Grid>
                          ))}
                        </Grid>
                      )) ||
                        ""}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 24, padding: "15px" }}>
                <Grid container direction="column">
                  {!mobileview &&
                    (sectionLinks || []).map((s) => (
                      <Grid
                        key={s.id}
                        item
                        xs={12}
                        className={classes.drawerLinks}
                      >
                        <a
                          style={{ color: "#0c44ac", textDecoration: "none" }}
                          href={s.path}
                          // target="_blank"
                          rel="noreferrer"
                        >
                          {s.label}
                        </a>
                      </Grid>
                    ))}
                  {mobileview &&
                    (MOBsectionLinks || []).map((s) => (
                      <Grid
                        key={s.id}
                        item
                        xs={12}
                        className={classes.drawerLinks}
                      >
                        <a
                          style={{ color: "#0c44ac", textDecoration: "none" }}
                          href={s.path}
                          // target="_blank"
                          rel="noreferrer"
                        >
                          {s.label}
                        </a>
                      </Grid>
                    ))}
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ marginTop: 40, padding: "15px" }}>
                <Grid container direction="column">
                  {/* <Grid item xs={12} className={classes.drawerLinks}>
                    <a
                      target="_blank"
                      // href={"/https://docs.google.com/spreadsheets/d/1uWUO0IQGk34ypf5roX681DtJvfdzOCBT/edit?usp=sharing&ouid=101004646910894655023&rtpof=true&sd=true"}
                      style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
                    >
                      Find Partner Branch
                    </a>
                  </Grid> */}
                  <Grid item xs={12} className={classes.drawerLinks}>
                    <a
                      // target="_blank"
                      style={{ color: "#0c44ac", textDecoration: "none" }}
                      href="https://forms.clickup.com/f/4hnn1-543/J66634MTO2OOU28XUR/"
                      rel="noreferrer"
                    >
                      Contact Us
                    </a>
                  </Grid>
                  <Grid item xs={12} className={classes.drawerLinks}>
                    <Link to={"/faq"} style={{ color: "#0c44ac" }}>
                      FAQs
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Drawer>
        </Hidden>
      </AppBar>
      <Grid container>{children}</Grid>
      <Grid container direction="column" className={classes.footer}>
        <Grid
          container
          xs={12}
          id="footer123"
          alignItems="center"
          justify="center"
          style={{ padding: "15px 0px" }}
        >
          <Grid
            container
            alignItems="center"
            justify="space-between"
            spacing={3}
          >
            <Grid
              item
              md={6}
              style={{ fontFamily: "visuelt-regular", fontSize: 24 }}
            >
              Get Doctall Diagnostics to your inbox
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={7} xs={12}>
                  <input
                    id="InputID"
                    type="text"
                    style={{ border: 0, outline: "none" }}
                    className={classes.InputMail}
                    placeholder="e.g someone@gmail.com"
                    defaultValue={joinMailId}
                    onChange={(event) => handleJoinMailId(event.target.value)}
                  />
                  {mailError && (
                    <small style={{ color: "#FFAD05" }}>
                      Please enter valid email address
                    </small>
                  )}
                </Grid>
                <Grid item lg={5} xs={12}>
                  <button className={classes.MailBtn} onClick={handleJoinMail}>
                    Join Mailing List
                  </button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          style={{ paddingBottom: "15px", paddingTop: "10px" }}
        >
          <hr />
        </Grid>
        <Grid item xs={12}>
          <Grid container direction="row" justify="space-between" spacing={3}>
            <Grid item md={4}>
              <Grid container direction="column" spacing={3}>
                <Grid item xs={12}>
                  <img src={Logo} alt="Logo" />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    fontFamily: "visuelt-regular",
                    fontSize: mobileview ? 16 : 14,
                  }}
                >
                  Doctall is a full-circle digital healthcare provider offering
                  comprehensive primary and secondary medical services
                  accessible anywhere, to everyone.
                </Grid>
                <Grid item xs={12}>
                  <a
                    style={{
                      fontFamily: "visuelt-regular",
                      fontSize: mobileview ? 16 : 14,
                    }}
                    href="tel:09010996000"
                  >
                    {/* +234-8301-340-3946 */}
                    09010996000
                  </a>
                  <div>
                    <a
                      style={{
                        fontFamily: "visuelt-regular",
                        fontSize: mobileview ? 16 : 14,
                      }}
                      href="mailto:info@doctall.com"
                    >
                      info@doctall.com
                    </a>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    justify="space-between"
                    style={{ maxWidth: "150px" }}
                  >
                    <Grid item>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/myDoctall/"
                        rel="noreferrer"
                      >
                        <img src={Icon2} alt="Icon2" />
                      </a>
                    </Grid>
                    <Grid item >
                      <a
                        target="_blank"
                        href="https://twitter.com/myDoctall"
                        rel="noreferrer"
                      >
                        {/* <img src={Icon} alt="Icon" /> */}
                        <svg   style={{ maxWidth: "25px" }}>
                   
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="white"></path>

                       
                              
                              </svg>
                      </a>
                    </Grid>
                    <Grid item>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/mydoctall/"
                        rel="noreferrer"
                      >
                        <img src={Icon4} alt="Icon4" />
                      </a>
                    </Grid>
                    <Grid item>
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/company/doctall/"
                        rel="noreferrer"
                      >
                        <img src={Icon5} alt="Icon4" />
                      </a>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item container direction="column" md={8}>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
              >
                {(mobileview ? mobfooterLinks || [] : footerLinks || []).map(
                  (f) => (
                    <Grid
                      key={f.id}
                      item
                      xs={6}
                      md={2}
                      style={{ padding: mobileview ? "12px" : "0" }}
                    >
                      {f.subroute && (
                        <Grid
                          container
                          style={{
                            marginBottom: 20,
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            className={classes.title}
                            onClick={() => {
                              setfooter(f.subroute.title);
                            }}
                          >
                            {f.subroute.title}{" "}
                            <img className="mob-footer-drop" src={FooterIcon} />
                          </Grid>
                          {f.subroute.routes && f.subroute.routes.length > 0
                            ? (((mobileview &&
                              footer.indexOf(f.subroute.title) > -1) ||
                              !mobileview) && (
                                <Grid container spacing={2}>
                                  {(f.subroute.routes || []).map((r) => (
                                    <Grid key={r.id} item xs={12}>
                                      {/* () => setpopup(false) */}
                                      {r.label === 'Find Partner Branch' ?
                                        // <label onClick={() => setpopup(true)}>
                                        //   {r.label}
                                        // </label>  
                                        <a
                                          // target="_blank"
                                          style={{
                                            fontFamily: "visuelt-regular",
                                            fontSize: 16,
                                            cursor: 'pointer'
                                          }}
                                          onClick={() => setpopup(true)}
                                        >
                                          {r.label}
                                        </a>
                                        :
                                        <a
                                          // target="_blank"
                                          style={{
                                            fontFamily: "visuelt-regular",
                                            fontSize: 16,
                                          }}
                                          href={r.path}
                                          rel="noreferrer"
                                        >
                                          {r.label}
                                        </a>
                                      }

                                    </Grid>
                                  ))}
                                </Grid>
                              )) ||
                            ""
                            : null}
                        </Grid>
                      )}
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          className={classes.title}
                          onClick={() => {
                            setfooter(f?.title);
                          }}
                        >
                          {f.title}{" "}
                          <img className="mob-footer-drop" src={FooterIcon} />
                        </Grid>
                        {f.routes && f.routes.length > 0
                          ? (((mobileview && footer.indexOf(f.title) > -1) ||
                            !mobileview) && (
                              <Grid container spacing={2}>
                                {(f.routes || []).map((r) => (
                                  <Grid key={r.id} item xs={12}>
                                    <a
                                      // target="_blank"
                                      style={{
                                        fontFamily: "visuelt-regular",
                                        fontSize: 16,
                                      }}
                                      href={r.path}
                                      rel="noreferrer"
                                    >
                                      {r.label}
                                    </a>
                                  </Grid>
                                ))}
                              </Grid>
                            )) ||
                          ""
                          : null}
                      </Grid>
                    </Grid>
                  )
                )}
              </Grid>
              <Grid item>
                <Grid item xs={12} style={{ paddingTop: "125px" }}>
                  <Grid container alignItems="center">
                    <Grid
                      item
                      style={{ marginRight: "50px", marginBottom: "5px" }}
                    >
                      <a
                        // target="_blank"
                        href="https://apps.apple.com/ng/app/doctall/id1544455716"
                        rel="noreferrer"
                      >
                        <img src={AppStore} alt="AppStore" />
                      </a>
                    </Grid>
                    <Grid
                      item
                      style={{ marginRight: "50px", marginBottom: "5px" }}
                    >
                      <a
                        // target="_blank"
                        href="https://play.google.com/store/apps/details?id=com.doctall"
                        rel="noreferrer"
                      >
                        <img src={GooglePlay} alt="GooglePlay" />{" "}
                      </a>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ paddingTop: "15px", paddingBottom: "15px" }}
        >
          <hr />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ textAlign: "center", fontSize: "16px", lineHeight: "24px" }}
        >
          {`© Doctall ${new Date().getFullYear()},  All Rights Reserved`}
        </Grid>
      </Grid>
    </div>
  );
}
const DropClick = (props) => {
  const ref = React.useRef();
  const [drop, setDrop] = React.useState(false);
  const [selection, setSelection] = React.useState("Pathology");
  useOnClickOutside(ref, () => {
    setDrop(false);
  });
  return (
    <div
      style={{ position: "relative", paddingLeft: 10 }}
      ref={ref}
      onClick={() => {
        setDrop(!drop);
      }}
    >
      <img style={{ cursor: "pointer" }} src={DownArrow} />
      {drop && (
        <div
          style={{
            position: "absolute",
            top: 37,
            right: -35,
            backgroundColor: "#ffffff",
            maxWidth: 235,
            minWidth: 200,
            boxShadow: "0px 4px 6px 2px #F5F9FF",
            border: "1px solid #E3EAF6",
            zIndex: 99,
          }}
        >
          <div
            onClick={() => {
              setSelection("Pathology");
            }}
            style={
              selection == "Pathology"
                ? {
                  color: "#163E8C",
                  fontSize: 16,
                  fontFamily: "visuelt-regular",
                  fontWeight: "500",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F2F5FE",
                  borderRightColor: "#FFAD05",
                  borderRightWidth: 2,
                  borderRightStyle: "solid",
                }
                : {
                  color: "#163E8C",
                  fontSize: 16,
                  fontFamily: "visuelt-regular",
                  fontWeight: "500",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                }
            }
          >
            <img style={{ paddingRight: 8, width: 18 }} src={DropItem} />
            Pathology
          </div>
          <div
            onClick={() => {
              setSelection("Radiology");
            }}
            style={
              selection == "Radiology"
                ? {
                  color: "#163E8C",
                  fontSize: 16,
                  fontFamily: "visuelt-regular",
                  fontWeight: "500",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F2F5FE",
                  borderRightColor: "#FFAD05",
                  borderRightWidth: 2,
                  borderRightStyle: "solid",
                }
                : {
                  color: "#163E8C",
                  fontSize: 16,
                  fontFamily: "visuelt-regular",
                  fontWeight: "500",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                }
            }
          >
            <img style={{ paddingRight: 8, width: 18 }} src={RadioDrop} />
            Radiology
          </div>
        </div>
      )}
    </div>
  );
};
